var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiCardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3361_12841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75H22.5C23.325 3.75 24 4.425 24 5.25V18.75C24 19.575 23.325 20.25 22.5 20.25H1.5C0.675 20.25 0 19.575 0 18.75V5.25C0 4.425 0.675 3.75 1.5 3.75Z",
    fill: "url(#paint0_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6H24V9.75H0V6Z",
    fill: "url(#paint1_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0.75H12C13.2375 0.75 14.25 1.7625 14.25 3V21C14.25 22.2375 13.2375 23.25 12 23.25H3C1.7625 23.25 0.75 22.2375 0.75 21V3C0.75 1.7625 1.7625 0.75 3 0.75Z",
    fill: "#D7F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24H3C1.35 24 0 22.65 0 21V3C0 1.35 1.35 0 3 0H12C13.65 0 15 1.35 15 3V21C15 22.65 13.65 24 12 24ZM3 1.5C2.175 1.5 1.5 2.175 1.5 3V21C1.5 21.825 2.175 22.5 3 22.5H12C12.825 22.5 13.5 21.825 13.5 21V3C13.5 2.175 12.825 1.5 12 1.5H3Z",
    fill: "url(#paint2_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3H5.625C4.8 3 4.125 2.325 4.125 1.5H10.875C10.875 2.325 10.2 3 9.375 3Z",
    fill: "url(#paint3_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5C9.98528 16.5 12 14.4853 12 12C12 9.51472 9.98528 7.5 7.5 7.5C5.01472 7.5 3 9.51472 3 12C3 14.4853 5.01472 16.5 7.5 16.5Z",
    fill: "url(#paint4_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.75C9.57107 15.75 11.25 14.0711 11.25 12C11.25 9.92893 9.57107 8.25 7.5 8.25C5.42893 8.25 3.75 9.92893 3.75 12C3.75 14.0711 5.42893 15.75 7.5 15.75Z",
    fill: "#7ECE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C7.275 13.5 7.3875 13.5375 5.7375 11.8875C5.5875 11.7375 5.5875 11.5125 5.7375 11.3625C5.8875 11.2125 6.1125 11.2125 6.2625 11.3625L7.5 12.6L9.4875 10.6125C9.6375 10.4625 9.8625 10.4625 10.0125 10.6125C10.1625 10.7625 10.1625 10.9875 10.0125 11.1375C7.5375 13.6125 7.725 13.5 7.5 13.5Z",
    fill: "url(#paint5_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21H3.75C3.525 21 3.375 20.85 3.375 20.625C3.375 20.4 3.525 20.25 3.75 20.25H11.25C11.475 20.25 11.625 20.4 11.625 20.625C11.625 20.85 11.475 21 11.25 21Z",
    fill: "url(#paint6_linear_3361_12841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18.375H17.25C17.025 18.375 16.875 18.225 16.875 18V16.5C16.875 16.275 17.025 16.125 17.25 16.125H21.75C21.975 16.125 22.125 16.275 22.125 16.5V18C22.125 18.225 21.975 18.375 21.75 18.375Z",
    fill: "url(#paint7_linear_3361_12841)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3361_12841",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3361_12841",
    x1: 0,
    y1: 7.875,
    x2: 24,
    y2: 7.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B756D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC9388"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3361_12841",
    x1: 0,
    y1: 12,
    x2: 15,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3361_12841",
    x1: 4.125,
    y1: 2.25,
    x2: 10.875,
    y2: 2.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3361_12841",
    x1: 3,
    y1: 12,
    x2: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CDD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3361_12841",
    x1: 5.6235,
    y1: 11.9996,
    x2: 10.1265,
    y2: 11.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3361_12841",
    x1: 3.375,
    y1: 20.625,
    x2: 11.625,
    y2: 20.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CCDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3361_12841",
    x1: 16.875,
    y1: 17.25,
    x2: 22.125,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3361_12841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiCardNew);
export default __webpack_public_path__ + "static/media/upi-card-new.3de75d39732007504fee63fca2d68512.svg";
export { ForwardRef as ReactComponent };